module.exports = __webpack_public_path__ + "static/cafe-722df3393f1995dddd3fd6bdfca1cc7a.jpg";